// Passive event listener config
export const PASSIVE = { passive: true }

// Popper `preventOverflow` padding
export const PADDING = 4

// Popper attributes
// In Popper v2 these will be `data-*` instead of `x-*` to adhere to HTML5 spec
export const PLACEMENT_ATTRIBUTE = 'x-placement'
export const OUT_OF_BOUNDARIES_ATTRIBUTE = 'x-out-of-boundaries'

// Classes
export const IOS_CLASS = 'tippy-iOS'
export const ACTIVE_CLASS = 'tippy-active'

// Selectors
export const POPPER_SELECTOR = '.tippy-popper'
export const TOOLTIP_SELECTOR = '.tippy-tooltip'
export const CONTENT_SELECTOR = '.tippy-content'
export const BACKDROP_SELECTOR = '.tippy-backdrop'
export const ARROW_SELECTOR = '.tippy-arrow'
export const ROUND_ARROW_SELECTOR = '.tippy-roundarrow'
